<template>
    <div id="bindphone">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">绑定手机号码</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>

        <form action="" class="form">
            <p>
                <input type="text" placeholder="手机号码" v-model.number.trim="bind.phone" :class="{'error-input':error.phone}" autocomplete="off">
            </p>
            <p>

                <input type="text" placeholder="验证码" v-model="bind.captcha" class="captcha" :class="{'error-input':error.captcha}" autocomplete="off">
                <span class="captcha-img"><img :src="captcha"  alt="" class="" @click="editCaptcha"></span>
            </p>
            <p class="getmess">
                <input type="mess" placeholder="短信验证码" v-model="bind.code" :class="{'error-input':error.code}" autocomplete="off">
                <span @click="getSms" >{{mess}}</span>
            </p>


        </form>
        <button class="btn" @click="doBind">立即绑定</button>

    </div>
</template>

<script>
    export default {
        name: "Bindphone",
        data (){
            return {
                bind : {
                    phone : '',
                    code : '',
                    captcha : ''
                },
                captcha : '/api/captcha.html',
                error:{
                    phone : false,
                    code : false,
                    captcha : false,

                },
                mess : '获取验证码',
            }
        },methods : {
            editCaptcha (){
                this.captcha = '/api/captcha.html?d=' + Math.random()
            },
            getSms(){
                var _this = this;

                var reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                if(!reg.test(this.bind.phone)){
                    this.error.phone = true;
                    this.$message.error('请输入正确的手机号码！');
                    return false;
                }
                this.error.phone = false;

                if(this.bind.captcha.length != 4){
                    this.error.captcha = true;
                    this.$message.error('验证码有误！');
                    return false;
                }
                this.error.captcha = false;

                if(this.getMess){
                    return false;
                }
                this.getMess = true;

                this.axios.post("/api/login/getSmsCode",{
                    phone : this.bind.phone,
                    vercode : this.bind.captcha,
                }).then(response => {
                    let data = response.data;
                    if(data.code > 0){
                        this.$message.success(data.msg);
                        let time = 60;
                        let t = setInterval(function () {
                            time --;
                            _this.mess = time + ' 秒'
                            if(time < 1){
                                clearInterval(t);
                                _this.mess = "获取验证码"
                                _this.getMess = false;
                                _this.editCaptcha();
                                _this.reg.captcha = '';
                            }
                        },1000)

                    }else{
                        this.$message.error(data.msg);
                        this.editCaptcha();
                        this.bind.captcha = '';
                        this.getMess = false;
                    }
                })

            },
            doBind(){
                if(this.bind.code.length != 6){
                    this.error.code = true;
                    this.$message.error('手机验证码有误！');
                    return false;
                }
                this.error.code = false;
                this.axios.post('/api/user/bindphone',{
                    phone : this.bind.phone,
                    smscode : this.bind.code
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else{
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$router.push('/user');
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#bindphone{background: #fff;overflow: auto;height: 100%;
    .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }

    .form{
        width:80%;margin:40px auto;box-sizing: border-box;border:1px solid #efefef;border-radius: 10px;overflow: hidden;


        p{position: relative;height: 96px;}
        i{position: absolute;z-index: 99;font-size: 40px;line-height: 96px;font-weight: bold;color: #999;}
        input{width: 100%;font-size:35px;position: absolute;border-radius:0;text-indent: 50px;border:none;border-bottom: 1PX solid #eee;height: 96px;line-height: 96px;z-index: 10;}
        .tool{height: 50px;line-height: 50px;
            a{font-size: 28px;}
        }
        .error-input{border-color: @theme;}

        .captcha{width: 300px;}

        .captcha-img{position: absolute;right: 0;top:12px;height: 70px;width: 250px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;
            img{width:100%;height:70px;}

        }
        .getmess{

            span{position: absolute;right: 0;top:12px;color:@theme;text-align:center;line-height:70px;width: 250px;height: 70px;z-index: 999;padding: 0 20px;border-left: 1px solid #efefef;}
        }
    }
    .btn{width:80%;background:@theme;color:#fff;border:none;margin:20px auto;display:block;height: 96px;font-size: 36px;border-radius: 10px !important;}

}
</style>
